import O1HD, { managers, services } from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { GAME_EVENT } from "./Enum";
import { ILosePagePrams } from "./Interface";

const { ccclass, property, menu, disallowMultiple } = cc._decorator;

@ccclass
@disallowMultiple
@menu('游戏页面/失败结算页')
export default class WinPage extends PageBase {
    @property({ type: cc.Label, displayName: "过关文字显示" })
    private winLabel: cc.Label = null;
    @property({ type: cc.Sprite, displayName: "过关显示图片" })
    private showImg: cc.Sprite = null;
    @property({ type: cc.Button, displayName: "分享按钮" })
    private shareBtn: cc.Button = null;
    @property({ type: cc.Node, displayName: "广告标识" })
    private adIcon: cc.Node = null;

    private tipsContent: string[] = [];

    async OnPageOpen(prams: ILosePagePrams) {
        this.tipsContent = prams.tips;
        let level: number = prams.index;
        let labelNode = this.node.getChildByName("Content").getChildByName("Label" + level);
        labelNode && (labelNode.active = true);
        this.winLabel.string = prams.loseText;
        super.OnPageOpen(prams);
        if (O1HD.getManagers().gameMgr.platName == "novelapp") {
            this.shareBtn.node.active = false;
        }
        services().miniGameSrv.getAppApiInstance().gameRecordStop();


        let dudceGold = 100000000;
        let gold = O1HD.getServices().userSrv.getCoins();
        dudceGold = Math.min(gold, dudceGold);
        O1HD.getServices().userSrv.setCoins(-dudceGold, true, null, null, null, false);
    }

    async OnRestartBtn() {
        managers().soundMgr.playSound('anNiu');
        // if (O1HD.getServices().userSrv.getPower() - gameConfig.MODE_POWER[this.m_mode] < 0) {
        //     mainRoot.UIModel.showUserPropGet(REWARD_TYPE.POWER, gameConfig.ADD_ONCE_POWER);
        //     return false;
        // }

        // await mainRoot.LevelSystem.LoadLevel(mainRoot.LevelSystem.GetSignleLevelInfo(this.m_mode).bundleName, this.m_mode, null, true, true);
        // services().userSrv.setPower(-gameConfig.MODE_POWER[this.m_mode], true, true);

        this.ClosePage();

        let onBack = this.m_prams['resetStart'];
        onBack && onBack();
    }

    async BackMain(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.modules().uiControlModule.CloseAllPage();
        let onBack = this.m_prams['onBack'];
        let eventId = this.m_prams['eventId'];
        onBack && onBack();

        if (eventId) {
            utilsView.openEventLayer(
                null
                , {
                    id: eventId
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                }
                , UI_Z_INDEX.DIALOG
            );
        }
    }

    OnShareBtn() {
        managers().soundMgr.playSound('anNiu');
        if (O1HD.getManagers().gameMgr.platName  == "novelapp") {
            return;
        }

        // if(services().ossSrv.getPlatform()=="ks"){
        //     this.shareBtn.node.active = false;
        // }
        services().miniGameSrv.getAppApiInstance().shareGameRecordVideo(() => {
            console.log('成功分享录屏');
            // this.shareBtn.node.active = false;
            // this.node.getChildByName("BtnRestart").setPosition(0,0)  //临时用一下 后面改oss资源
        }, (any)=> {
            console.log('分享录屏失败', any);
            O1HD.getModules().uiControlModule.showMessageBox('分享失败');
        });

    }
}